import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import FileUpload from "../../Component/FileUpload/FileUpload";

const News = () => {
  return (
    <Container fluid className="news-page">
      <div className="news-head">
        <div>
          <p>Home / News</p>
          <h1>News</h1>
        </div>
        <Link to="/dashboard/add_news" className="dashboard-panel-link">
          Add news
        </Link>
      </div>
      <FileUpload mode="list" />
    </Container>
  );
};

export default News;
